import {createContext} from 'react';

import {FilterFieldName} from '../utils/getFilterSections';

export const FilterFieldsContext = createContext<FilterFieldName[] | null>(null);
